<div class="xvi-number-input-renderer" [ngClass]="class">
  <input
    #inputElement
    [ngClass]="class"
    [attr.type]="type"
    [attr.placeholder]="placeholder"
    [attr.disabled]="disabled ? 'true' : null"
    (keyup)="onKeyup($event)"
    (keydown)="onKeydown($event)"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut()"
    (gridCustomFocus)="onGridCustomFocus($event)"
    [(ngModel)]="value"
    [attr.customScanning]="true"
  />
</div>
